<template lang="pug">
  button.baseButton.is-loading(
    v-if="loading"
    :disabled="loading"
    @click="$emit('clicked')"
  )
  button(
    v-else
    @click="$emit('clicked')"
    :class="{'outline': outline, 'is-countdown': isCountdown, 'baseButton': !countButton, 'btn-count': countButton }"
    :disabled="isCountdown"
  )
    span.progress(
      v-if="isCountdown"
      :style="`width: calc(${progress}/60 * 100%); opacity:  ${(progress/30) * 2};`")
    slot
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    outline: {
      type: Boolean,
      default: () => false,
    },
    isCountdown: {
      type: Boolean,
      default: false,
    },
    countButton: {
      type: Boolean,
      default: false,
    },
    progress: {
      type: Number,
      default: () => 0,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@design";
.baseButton {
  @extend %typography-small;
  overflow: hidden;
  background: $color-link-text;
  color: $color-button-text;
  font-weight: $subheading-font-weight;
  text-transform: uppercase;
  text-decoration: none;
  display: block;
  padding: 1rem;
  letter-spacing: 0.05rem;
  border-radius: 5rem;
  outline: none;
  border: none;
  width: 100%;
  transition: all 0.3s ease;
  min-width: 10rem;
  cursor: pointer;
  span {
    opacity: 0;
    transition: all 0.3s ease;
  }
  &.outline {
    background-color: transparent;
    border: 2px solid $color-link-text;
    color: $color-link-text;
    padding: 0.99rem;
    position: relative;

    &.is-countdown {
      transition: all 0.3s ease;
    }
    .progress {
      z-index: -1;
      display: block;
      position: absolute;
      background: rgba($color-heading-text, 0.3);
      top: 0;
      left: 0;
      height: 100%;
      transition: all 0.3s ease;
    }
    &:hover {
      background-color: transparent;
    }
  }

  &:hover {
    box-shadow: 0 0.2rem 1.8rem 0 rgba($color-heading-dark, 80%);
  }
  @media (min-width: $vh-mobile) {
    width: auto;
  }
}
.is-loading {
  cursor: not-allowed;
  &::before {
    content: "";
    display: block;
    margin: 0 auto;
    height: 20px;
    width: 20px;
    border: 2px solid mix(white, $color-link-text, 35%);
    border-left-color: mix(black, $color-link-text, 45%);
    border-radius: 50%;
    animation: rotate-center 0.4s linear infinite both;
  }
}

.btn-count {
  border: none;
  background-color: transparent;
  font-weight: bold;
  text-decoration: underline;
  color: #707070;
  padding-left: 0.5rem;
  text-align: start;
}

@-webkit-keyframes rotate-center {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes rotate-center {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
